import WhiteLabelConfig, { WhiteLabelTitle } from 'types/models/white-label';
import { whiteLabelDomains } from 'utils/construct-enterprise-domain';

const {
  VITE_AUTH0_CLIENT_FARMBOT,
  VITE_AUTH0_CLIENT_RANCHBOT,
  VITE_AUTH0_CLIENT_MINEBOT
} = import.meta.env;

export const farmbotConfig: WhiteLabelConfig = {
  title: WhiteLabelTitle.FARMBOT,
  description: 'Farmbot Monitoring Solutions',
  faviconName: 'farmbotFavicon.ico',
  auth0ClientId: VITE_AUTH0_CLIENT_FARMBOT
};

export const ranchbotConfig: WhiteLabelConfig = {
  title: WhiteLabelTitle.RANCHBOT,
  description: 'Ranchbot Monitoring Solutions',
  faviconName: 'ranchbotFavicon.ico',
  auth0ClientId: VITE_AUTH0_CLIENT_RANCHBOT
};

export const minebotConfig: WhiteLabelConfig = {
  title: WhiteLabelTitle.MINEBOT,
  description: 'Minebot Monitoring Solutions',
  faviconName: 'minebotFavicon.ico',
  auth0ClientId: VITE_AUTH0_CLIENT_MINEBOT
};

const configs: Record<string, WhiteLabelConfig> = {
  farmbot: farmbotConfig,
  'ranch-bot': ranchbotConfig,
  minebot: minebotConfig
};

/**
 * Detects the domain name and returns a configuration object
 * containing properties the title, description, logo and faviconName.
 */
const getWhiteLabelConfig = () => {
  const enterpriseDomain = window.location.hostname;
  const currentDomain = whiteLabelDomains.find((domain) =>
    enterpriseDomain.includes(domain)
  );
  const config = currentDomain && configs[currentDomain];
  return config || farmbotConfig;
};

export default getWhiteLabelConfig;
